import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name' }
      ]
    },
    clientname: {
      validations: [
        { type: 'required', message: 'Please provide a company or organization' }
      ]
    },
    addressline1: {
      validations: []
    },
    city: {
      validations: []
    },
    state: {
      validations: []
    },
    postal: {
      validations: []
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    telnumber: {
      validations: [
        { type: 'required', message: 'Please provide a phone number' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    accountextra5: {
      validations: []
    },
    eventDate: {
      validations: [
        { type: 'required', message: 'Please select preferred event date' },
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    theme: {
      validations: []
    },
    plannedguestcount: {
      validations: [
        { type: 'required', message: 'Please provide approximate number of guests' },
      ]
    },
    eventextra8: {
      validations: [
        { type: 'required', message: 'Please provide a budget' }
      ]
    },
    reference: {
      validations: []
    },
    notes: {
      validations: []
    },
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name*:',
            mapping: 'firstName'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name*:',
            mapping: 'lastName'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Company or Organization*:',
            mapping: 'clientname',
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Address',
            mapping: 'addressline1'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'City',
            mapping: 'city'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'State',
            mapping: 'state'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Zip Code',
            mapping: 'postal'
          },
        ]
      },
      {
        fields: [
          {
          type: 'text',
          size: 'Medium',
          label: 'Email*:',
          mapping: 'email'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Daytime Phone*:',
            mapping: 'telnumber'
          },
        ]
      },
      {
        fields: [
          {
          type: 'multiple-choice',
          size: 'Medium',
          label: 'Preferred Contact Method:',
          options: [
            { label: 'Email' , value: 'Email'},
            { label: 'Phone', value: 'Phone' }
          ],
          mapping: 'accountextra5'
        }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Preferred Event Date*:',
            mapping: 'eventDate'
          }
        ]
      },
      {
        fields: [
          {
          type: 'multiple-choice',
          size: 'Medium',
          label: 'Type of Event:',
          options: [
            { label: 'Corporate Event', value: 'Corporate Event'},
            { label: 'Social Event', value: 'Social Event'},
            { label: 'Wedding', value: 'Wedding' },
            { label: 'Other', value: 'Other'}
          ],
          mapping: 'theme'
        }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Approximate Number of Guests*:',
            mapping: 'plannedguestcount'
          }
        ]
      },
      {
        fields: [
          {
          type: 'text',
          size: 'Medium',
          label: 'Budget*:',
          mapping: 'eventextra8'
        }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'How did you hear about the Aquarium:',
            options: [
              { label: 'BizBash', value: 'BizBash'},
              { label: 'Shedd Member', value: 'Shedd Member'},
              { label: 'Shedd Website', value: 'Shedd Website'},
              { label: 'Social Media', value: 'Social Media' },
              { label: 'Choose Chicago', value: 'Choose Chicago' },
              { label: 'CS Brides', value: 'CS Brides' },
              { label: 'Other', value: 'Other'},
              { label: 'EventUp', value: 'EventUp'},
              { label: 'PartySlate', value: ' PartySlate'},
              { label: 'Here’s Chicago', value: 'Here’s Chicago'},
              { label: 'Online Search', value: 'Online Search'},
              { label: 'LinkedIn Ad', value: 'LinkedIn Ad'},
              { label: 'Parties Chicago (Celebration Authority)', value: 'Parties Chicago (Celebration Authority)'},
              { label: 'Unique Venues', value: 'Unique Venues'},
              { label: 'Chicago Concierge', value: 'Chicago Concierge'},
            ],
            mapping: 'reference'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'XLarge',
            label: 'Additional Event Details:',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Send'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Sodexo at John G. Shedd Aquarium Contact Form',
    formId: '188',
    clientKey: '9835DF64-78B5-49A6-A3D8-1A31898180A2',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: 'https://www.sheddaquarium.org/plan-a-visit/plan-a-private-event/spectacular-spaces',
    submissionText: 'Thank you! Your inquiry has been successfully sent. We will contact you very soon!',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/client_forms/sodexojohng/form_structure.js